import { Button } from '@seen/ui'
import type { JSX } from 'react'
import { Dialog } from '#src/components/core/dialog/Dialog.tsx'
import { DialogContent } from '#src/components/core/dialog/DialogContent.tsx'
import { DialogDescription } from '#src/components/core/dialog/DialogDescription.tsx'
import { DialogFooter } from '#src/components/core/dialog/DialogFooter.tsx'
import { DialogHeader } from '#src/components/core/dialog/DialogHeader.tsx'
import { DialogTitle } from '#src/components/core/dialog/DialogTitle.tsx'
import { DialogDisplay } from '#src/components/core/dialog/display/DialogDisplay.tsx'
import { useConfirmationStore } from '#src/hooks/useConfirmationStore.ts'

export function ConfirmationDialog(): JSX.Element {
  // Note we have ConfirmationDialog at the app level. This is because certain actions (i.e. deleting from a context menu) wouldn't work with a local confirmation dialog since the context menu gets unmounted when the action is triggered.

  const isOpen = useConfirmationStore((state) => state.isOpen)
  const title = useConfirmationStore((state) => state.title)
  const description = useConfirmationStore((state) => state.description)
  const onConfirm = useConfirmationStore((state) => state.onConfirm)
  const setIsOpen = useConfirmationStore((state) => state.setIsOpen)

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogDisplay>
        <DialogHeader asChild>
          <DialogTitle>
            <p>{title}</p>
          </DialogTitle>
        </DialogHeader>
        <DialogContent className="py-0">
          <DialogDescription>{description}</DialogDescription>
        </DialogContent>
        <DialogFooter className="mt-2 sm:flex-row-reverse sm:justify-start">
          <Button
            onClick={() => {
              onConfirm()
              setIsOpen(false)
            }}
          >
            Confirm
          </Button>
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogDisplay>
    </Dialog>
  )
}
